import React, { useState, useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import TablePagination from "@material-ui/core/TablePagination";
import {
  getFilterVacanciesRH,
  closeAVacant,
} from "../../actions/vacant-actions";
import { useStateValue } from "../../context/store";
import { headers } from "./models";
import ModalConfirmBaseSelect from "../../utils/form/modalConfirmBaseSelect";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import { Grid, Typography } from "@material-ui/core";
import DetailedAccordionVacanciesRH from "./detailedAccordionVacanciesRH";
import SearchVacancieRH from "./searchVacancieRH";
import Search from "../../images/icons/search.svg";
import Utils from "../../utils/utils";
import { ERROR_MESSAGE, MAESTRAS } from "../../constants";
import { getMaestras } from "../../actions/maestras-actions";
import { permissionsConstans } from "../../constansPermissions";

const VacanciesRH = (props) => {
  const _ = require("lodash");
  const [{ filterVacantRH, breadCrumb }, dispatch] = useStateValue();
  const [permissionsVacancies, setPermissionsVacancies] = useState([]);
  const [maestras, setMaestras] = useState({
    motivoCierreVacante: [],
    tipoContrato: [],
  });
  const [message, setMessage] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    oneButtons: false,
    buttonOneText: "",
    type: "",
  });
  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    buttonOneText: "",
    type: "",
    title: "Cerrar Vacante",
    option: {
      name: "",
      data: [],
      key: "",
      value: "",
    },
  });

  const [filter, setFilter] = useState({
    initDate: null,
    endDate: null,
    regional: null,
    status: null,
    chargeRequested: null,
  });

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Gestionar Vacantes",
      breadCrumbSubText: "Gestionar Vacantes",
      index: 16,
    });
  }, []);

  const ordenarMaestras = (maestras) => {
    maestras.motivoCierreVacante = _.sortBy(
      maestras.motivoCierreVacante,
      (o) => o
    );
    return maestras;
  };

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  useEffect(() => {
    const getListaMaestras = async () => {
      const response = await getMaestras();
      let orderMaestras = ordenarMaestras(
        response.data && response.data.maestras
      );
      setMaestras(orderMaestras);
    };
    getListaMaestras();
  }, []);

  const { path } = useRouteMatch();

  const getVacants = async () => {
    var d = new Date();
    //d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
    //d.setHours(0, 0, 0, 0);

    var initDate = filter.initDate
      ? Utils.getFormattedDateyyyyMMdd(filter.initDate, "-")
      : null;

    if (filter.endDate) {
      filter.endDate.setHours(1, 1, 1, 1);
    }
    const response = await getFilterVacanciesRH(
      {
        initDate: initDate,
        endDate: filter.endDate
          ? filter.endDate.toISOString().split("T")[0]
          : d.toISOString().split("T")[0],
        regional: filter.regional === "" ? null : filter.regional,
        status: filter.status === "" ? null : filter.status,
        chargeRequested:
          filter.chargeRequested === "" ? null : filter.chargeRequested,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch
    );
    if (response.data) {
      const data = response.data.vacantResponsePage;
      if (data.content?.length > 0) {
        setPaginadorResponse({
          data: data.content,
          totalRows: data.totalElements,
          pageSize: data.size,
          pageNumber: data.number,
        });
      }
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  useEffect(() => {
    const responsePersmissions = Utils.validationPermissions("VAC_PRIV");
    setPermissionsVacancies(responsePersmissions);
    getVacants();
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Vacantes",
      breadCrumbSubText: "Vacantes",
      index: 18,
    });
  }, [paginadorRequest]);

  if (
    filterVacantRH &&
    filterVacantRH?.isFilter &&
    filter !== filterVacantRH.filter
  ) {
    var newfilter = filterVacantRH.filter;
    filter.initDate = newfilter.initDate;
    filter.endDate = newfilter.endDate;
    filter.status = newfilter.status;
    filter.chargeRequested = newfilter.chargeRequested;
    filter.regional = newfilter.regional;
    paginadorRequest.page = 0;
    getVacants();
    dispatch({
      type: "SET_VACANCY_FILTER_RH",
      isFilter: false,
    });
  }

  const closeMessage = () => {
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const closeVacant = async (id, requisitionId, motivo) => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
    const response = await closeAVacant(
      {
        id: id,
        requisition: requisitionId,
        observation: motivo.observation,
        reason: motivo.motivoText,
      },
      dispatch
    );
    if (
      response &&
      (response.status === 200 ||
        response.status === 201 ||
        response.status === 202)
    ) {
      setMessage({
        description: "La vacante fue cerrada satisfactoriamente",
        textButtonSubmit: "Aceptar",
        handleClick: closeMessage,
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
      getVacants();
    } else {
      dispatch({
        type: "OPEN_SNACKBAR",
        openMessage: {
          open: true,
          message: response ? response?.data?.detail : ERROR_MESSAGE,
        },
      });
      closeMessage();
    }
  };

  const closeVacantConfirm = (id, requisitionId) => {
    setConfirm((anterior) => ({
      ...anterior,
      open: true,
      question: "",
      handleClick: (motivo) => closeVacant(id, requisitionId, motivo),
      handleClickOut: closeModal,
      buttonOneText: "ACEPTAR",
      type: "QUESTION",
      title: "Cerrar Vacante",
      option: {
        name: "Motivo",
        data: maestras.motivoCierreVacante,
        key: "clave",
        value: "valor",
      },
    }));
  };

  const validationPermissionSearch = () => {
    if (
      permissionsVacancies?.functionalities?.some(
        (x) => x === permissionsConstans.VAC_PRIV_CONSULTAR
      )
    ) {
      return <SearchVacancieRH />;
    }
  };

  return (
    <div style={{ marginTop: "15px" }}>
      <ModalConfirmBase
        open={message.open}
        description={message.description}
        handleClickOut={message.handleClickOut}
        handleClick={message.handleClick}
        textButtonSubmit={message.buttonOneText}
        oneButtons={message.oneButtons}
        type={message.type}
      />
      <ModalConfirmBaseSelect
        open={confirm.open}
        description={confirm.question}
        handleClickOut={confirm.handleClickOut}
        handleClick={confirm.handleClick}
        textButtonSubmit={confirm.buttonOneText}
        type="QUESTION"
        title={confirm.title}
        option={confirm.option}
      />

      {validationPermissionSearch()}
      {paginadorResponse.data.map((row, index) => (
        <DetailedAccordionVacanciesRH
          headers={headers}
          data={row}
          props={props}
          maestras={maestras}
          //onView={verRequisicion}
          onClose={closeVacantConfirm}
          functionalities={permissionsVacancies?.functionalities}
        />
      ))}

      {paginadorResponse.totalRows !== 0 ? (
        <TablePagination
        style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
          labelRowsPerPage="Registros por página"
        />
      ) : (
        <div>
          <div
            style={{
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "10%",
              display: "flex",
            }}
          >
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado.
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

export default withRouter(VacanciesRH);
